import { render, staticRenderFns } from "./ParticipantsMerge.vue?vue&type=template&id=28892460"
import script from "./ParticipantsMerge.vue?vue&type=script&lang=js"
export * from "./ParticipantsMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports